import {openDockedPanel, registerDockedPanel} from '@/Layouts/dock'

export interface ChatPanelSnapshot {
    open: boolean
    /** The channel the panel shows, kept across minimize and Inertia visits; `null` for the list. */
    channelId: string | null
}

type Listener = () => void

let snapshot: ChatPanelSnapshot = {open: false, channelId: null}
let organizationId: string | null | undefined
const listeners = new Set<Listener>()

const publish = (next: ChatPanelSnapshot): void => {
    if (next.open === snapshot.open && next.channelId === snapshot.channelId) {
        return
    }

    snapshot = next

    for (const listener of listeners) {
        listener()
    }
}

export const subscribeChatPanel = (listener: Listener): (() => void) => {
    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}

export const getChatPanelSnapshot = (): ChatPanelSnapshot => snapshot

/** One docked panel at a time (`dock.ts`): opening chat minimizes the assistant, and the reverse. */
export const openChatPanel = (): void => {
    openDockedPanel('chat')
    publish({...snapshot, open: true})
}

export const minimizeChatPanel = (): void => {
    publish({...snapshot, open: false})
}

export const toggleChatPanel = (): void => {
    if (snapshot.open) {
        minimizeChatPanel()
    } else {
        openChatPanel()
    }
}

export const rememberChatChannel = (channelId: string | null): void => {
    publish({...snapshot, channelId})
}

/**
 * The first organization is recorded. A later change closes the panel and forgets the channel, which belonged
 * to the other organization. The same organization leaves both alone.
 */
export const syncChatPanelOrganization = (id: string | null): void => {
    if (organizationId === undefined) {
        organizationId = id

        return
    }

    if (id === organizationId) {
        return
    }

    organizationId = id
    publish({open: false, channelId: null})
}

registerDockedPanel('chat', minimizeChatPanel)

export const resetChatPanelShell = (): void => {
    snapshot = {open: false, channelId: null}
    organizationId = undefined
    listeners.clear()
}
